export default __webpack_public_path__ + "static/media/blog-41-1.0d8098a8.png";